import { StrictMode } from 'react';

import ReactDOM from 'react-dom/client';
import Snowfall from 'react-snowfall';

import { App } from './App';

let container: HTMLElement | null = null;

document.addEventListener('DOMContentLoaded', () => {
  if (!container) {
    container = document.getElementById('root') as HTMLElement;
    const root = ReactDOM.createRoot(container);
    const winter = [11, 0, 1];
    const isWinter = winter.includes(new Date().getMonth());

    root.render(
      <StrictMode>
        <App />
        {/* eslint-disable-next-line react-extra/no-inline-styles */}
        {isWinter && <Snowfall style={{ position: 'fixed', top: 0 }} />}
        {/* <div className="h-[600px] w-[100vw] sticky top-0"> */}
        {/* </div> */}
      </StrictMode>
    );
  }
});
